import { createStore, applyMiddleware, compose } from "redux";
import rootReducer, { reducers } from "./rootReducer";
import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
import { saveState, loadState } from "../logic/ClientStorage";

// Externals
import throttle from 'lodash/throttle';

function configureStore() {
  //support for Redux dev tools
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const persistedState = combineStates();
  const store = createStore(rootReducer, persistedState, composeEnhancers(applyMiddleware(reduxImmutableStateInvariant())));
  store.subscribe(throttle(() => handleChange(store)), 1000);

  return store;
}

function combineStates() {
  let result = {};
  Object.keys(reducers).forEach(key => {
    let subState = loadState(key);
    result = { ...result, ...subState };
  });
  return result;
}

let currentValue;
function handleChange(store) {
  let previousValue = currentValue;
  currentValue = store.getState();

  Object.keys(reducers).forEach(key => {
    let currentSubValue = currentValue[key];
    let previousSubValue = previousValue ? previousValue[key] : null;

    if (hasChanged(currentSubValue, previousSubValue)) {
      saveState(key, currentSubValue);
      console.log("STATE saved", key);
    }
  });
}

function hasChanged(previousSubState, currentSubState) {
  return (previousSubState !== currentSubState);
}

export default configureStore();